/**
 * Represents an building.
 */
export interface BuildingModel {
  _id: string;
  name: string;
  organization: string;
  location: BuildingLocationModel;
  googlePlaceId?: string;
  images: string[];
  expand?: boolean;
  properties: BuildingPropertyInfoModel[];
  code: string;
  metadata: {
    createdAt: string;
    updatedAt: string;
  };
}

export interface BuildingPropertyInfoModel {
  _id: string;
  name: string;
  code: string;
  location: BuildingLocationModel & {
    floor: string;
    apartment: string;
  };
}

export interface BuildingLocationModel {
  address: string;
  street: string;
  streetNumber: string;
  country: string;
  postalCode: string;
  city: string;
  state: string;
  timezone: string;
  geometry: {
    lat: number;
    lng: number;
  };
}
